var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"playground d-flex flex-row align-center"},[_vm._m(0),(Boolean(_vm.toolkit))?_c('tool-kit',_vm._b({staticClass:"details"},'tool-kit',_vm.toolkit,false)):_vm._e()],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("Toolkit Playground")])])
}]

export { render, staticRenderFns }